// extracted by mini-css-extract-plugin
export var bigText = "Specialties-module--big-text--364bf";
export var image = "Specialties-module--image--4c66e";
export var moreTitle = "Specialties-module--more-title--fcc7e";
export var moreWrapper = "Specialties-module--more-wrapper--9bf18";
export var richText = "Specialties-module--rich-text--c4672";
export var text = "Specialties-module--text--09b08";
export var title = "Specialties-module--title--c1e88";